import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogOut } from "lucide-react";

export function AdminLoginForm({ onLogin, loginLoading }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className="page-transition pt-20 min-h-screen bg-[#F7F9FC] flex items-center justify-center" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#0B2545]/10 bg-white p-10">
        <h1 className="text-2xl font-black text-[#0B2545] mb-1" style={{ fontFamily: "Chivo, sans-serif" }}>Admin Dashboard</h1>
        <p className="text-xs text-slate-500 mb-8">GACA International — Management Portal</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-[10px] font-bold uppercase tracking-wider text-[#0B2545] mb-1 block">Email</Label>
            <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none h-11" />
          </div>
          <div>
            <Label className="text-[10px] font-bold uppercase tracking-wider text-[#0B2545] mb-1 block">Password</Label>
            <Input type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-11" />
          </div>
          <button type="submit" disabled={loginLoading} data-testid="admin-login-button" className="w-full bg-[#0B2545] text-white py-3 text-sm font-semibold uppercase tracking-wider hover:bg-[#13A8BD] transition-colors">
            {loginLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export function AdminHeader({ currentUser, onRefresh, onLogout }) {
  return (
    <div className="bg-[#0B2545] py-4 px-6 lg:px-12 flex items-center justify-between sticky top-0 z-40">
      <div>
        <h1 className="text-base font-black text-white" style={{ fontFamily: "Chivo, sans-serif" }}>GACA Admin</h1>
        <p className="text-[10px] text-white/40 uppercase tracking-wider">{currentUser?.name} — {currentUser?.role}</p>
      </div>
      <div className="flex items-center gap-4">
        <button onClick={onRefresh} className="text-[10px] text-white/50 hover:text-white uppercase tracking-wider">Refresh</button>
        <button onClick={onLogout} data-testid="admin-logout" className="flex items-center gap-1 text-[10px] text-white/50 hover:text-white uppercase tracking-wider">
          <LogOut size={12} /> Logout
        </button>
      </div>
    </div>
  );
}
